module.exports = __webpack_public_path__ + "img/banner-icon-02.fea7cdd2.svg";